/* AUURAH Fragrance Finder Quiz v7: First Name Capture + Klaviyo Event */
(function() {
  'use strict';

  var STORAGE_KEY = 'auurah_scent_profile_v1';

  function init() {
    var wrapper = document.getElementById('fragranceFinder');
    if (!wrapper) return;
    if (wrapper.getAttribute('data-initialized') === 'true') { renderWelcomeBack(); return; }
    wrapper.setAttribute('data-initialized', 'true');

    var quizAnswers = {};
    var currentQ = 0;
    var lastKey = null;

    var fragrances = {
      wsn_b: [
        {num:"No.153", name:"Velvet Night", notes:"Lavender - Vanilla - Amber", url:"/products/auurah-no-153-velvet-night"},
        {num:"No.456", name:"Crystal Rouge", notes:"Saffron - Jasmine - Amberwood", url:"/products/auurah-no-456-crystal-rouge"}
      ],
      wsn_e: [
        {num:"No.384", name:"Velvet Bloom", notes:"Pear - Vanilla - Amber", url:"/products/auurah-no-384-velvet-bloom"},
        {num:"No.341", name:"Magnetic", notes:"Chestnut - Spice - Vanilla", url:"/products/auurah-no-341-magnetic"}
      ,{num:"No.783", name:"Rose Veil", notes:"Mandarin - Jasmine - Rose", url:"/products/auurah-no-783-rose-veil"}],
      wsd_b: [
        {num:"No.341", name:"Magnetic", notes:"Chestnut - Spice - Vanilla", url:"/products/auurah-no-341-magnetic"},
        {num:"No.527", name:"Dark Eden", notes:"Passion Fruit - Oud - Leather", url:"/products/auurah-no-527-dark-eden"}
      ],
      wsd_e: [
        {num:"No.218", name:"Unbound", notes:"Lavender - Orange Blossom - Vanilla", url:"/products/auurah-no-218-unbound"},
        {num:"No.384", name:"Velvet Bloom", notes:"Pear - Vanilla - Amber", url:"/products/auurah-no-384-velvet-bloom"}
      ,{num:"No.783", name:"Rose Veil", notes:"Mandarin - Jasmine - Rose", url:"/products/auurah-no-783-rose-veil"}],
      wdn_b: [
        {num:"No.527", name:"Dark Eden", notes:"Passion Fruit - Oud - Leather", url:"/products/auurah-no-527-dark-eden"},
        {num:"No.672", name:"Nomad Shadow", notes:"Oud - Raspberry - Incense", url:"/products/auurah-no-672-nomad-shadow"}
      ],
      wdn_e: [
        {num:"No.418", name:"Obsidian", notes:"Leather - Cardamom - Amber", url:"/products/auurah-no-418-obsidian"},
        {num:"No.734", name:"Imperial Woods", notes:"Rose - Cinnamon - Oud", url:"/products/auurah-no-734-imperial-woods"}
      ],
      wdd_b: [
        {num:"No.418", name:"Obsidian", notes:"Leather - Cardamom - Amber", url:"/products/auurah-no-418-obsidian"},
        {num:"No.087", name:"Wild Ember", notes:"Bergamot - Pepper - Woods", url:"/products/auurah-no-087-wild-ember"}
      ],
      wdd_e: [
        {num:"No.783", name:"Rose Veil", notes:"Mandarin - Jasmine - Rose", url:"/products/auurah-no-783-rose-veil", tags:{warmth:"warm", sweet:"sweet", time:"day", vibe:"elegant"}},       {num:"No.901", name:"Blue Horizon", notes:"Citrus - Ginger - Cedar", url:"/products/auurah-no-901-blue-horizon"},
        {num:"No.087", name:"Wild Ember", notes:"Bergamot - Pepper - Woods", url:"/products/auurah-no-087-wild-ember"}
      ],
      fsn_b: [
        {num:"No.009", name:"Pineapple Smoke", notes:"Pineapple - Birch - Musk", url:"/products/auurah-no-009-pineapple-smoke"},
        {num:"No.547", name:"Electric Bloom", notes:"Cherry - Peony - Vanilla", url:"/products/auurah-no-547-electric-bloom"}
      ],
      fsn_e: [
        {num:"No.218", name:"Unbound", notes:"Lavender - Orange Blossom - Vanilla", url:"/products/auurah-no-218-unbound"},
        {num:"No.456", name:"Crystal Rouge", notes:"Saffron - Jasmine - Amberwood", url:"/products/auurah-no-456-crystal-rouge"}
      ],
      fsd_b: [
        {num:"No.009", name:"Pineapple Smoke", notes:"Pineapple - Birch - Musk", url:"/products/auurah-no-009-pineapple-smoke"},
        {num:"No.291", name:"Solstice", notes:"Grapefruit - Ginger - Amber", url:"/products/auurah-no-291-solstice"}
      ],
      fsd_e: [
        {num:"No.614", name:"Daydream", notes:"Bergamot - Ginger - Black Tea", url:"/products/auurah-no-614-daydream"},
        {num:"No.901", name:"Blue Horizon", notes:"Citrus - Ginger - Cedar", url:"/products/auurah-no-901-blue-horizon"}
      ],
      fdn_b: [
        {num:"No.291", name:"Solstice", notes:"Grapefruit - Ginger - Amber", url:"/products/auurah-no-291-solstice"},
        {num:"No.087", name:"Wild Ember", notes:"Bergamot - Pepper - Woods", url:"/products/auurah-no-087-wild-ember"}
      ],
      fdn_e: [
        {num:"No.418", name:"Obsidian", notes:"Leather - Cardamom - Amber", url:"/products/auurah-no-418-obsidian"},
        {num:"No.614", name:"Daydream", notes:"Bergamot - Ginger - Black Tea", url:"/products/auurah-no-614-daydream"}
      ],
      fdd_b: [
        {num:"No.901", name:"Blue Horizon", notes:"Citrus - Ginger - Cedar", url:"/products/auurah-no-901-blue-horizon"},
        {num:"No.087", name:"Wild Ember", notes:"Bergamot - Pepper - Woods", url:"/products/auurah-no-087-wild-ember"}
      ],
      fdd_e: [
        {num:"No.614", name:"Daydream", notes:"Bergamot - Ginger - Black Tea", url:"/products/auurah-no-614-daydream"},
        {num:"No.291", name:"Solstice", notes:"Grapefruit - Ginger - Amber", url:"/products/auurah-no-291-solstice"}
      ]
    };

    var profiles = {
      wsn_b: {name:'The Amber Sovereign', desc:'Opulent and commanding. You live for rich gourmands that own the evening.', traits:['Warm','Gourmand','Evening','Bold']},
      wsn_e: {name:'The Golden Muse', desc:'Luxurious and magnetic. Soft sweetness wrapped in after-dark elegance.', traits:['Warm','Gourmand','Evening','Elegant']},
      wsd_b: {name:'The Sunlit Maverick', desc:'Golden-hour confidence. Sweet warmth that leads from the front.', traits:['Warm','Gourmand','Day','Bold']},
      wsd_e: {name:'The Silk Horizon', desc:'Effortless daytime refinement. Soft, radiant, quietly luxurious.', traits:['Warm','Gourmand','Day','Elegant']},
      wdn_b: {name:'The Oud Monarch', desc:'Deep woods and quiet power. A presence felt before it is seen.', traits:['Warm','Woody','Evening','Bold']},
      wdn_e: {name:'The Twilight Poet', desc:'Refined after-dark sophistication. Woods and spice, softly spoken.', traits:['Warm','Woody','Evening','Elegant']},
      wdd_b: {name:'The Spiced Pathfinder', desc:'Warm spice and forward momentum. Built for days that demand presence.', traits:['Warm','Woody','Day','Bold']},
      wdd_e: {name:'The Cashmere Connoisseur', desc:'Understated daytime luxury. Textured woods with a soft touch.', traits:['Warm','Woody','Day','Elegant']},
      fsn_b: {name:'The Sparkling Rebel', desc:'Luminous and unexpected. Fresh sweetness with an electric edge.', traits:['Fresh','Gourmand','Evening','Bold']},
      fsn_e: {name:'The Moonflower Dreamer', desc:'Airy and romantic. Fresh petals that glow after dark.', traits:['Fresh','Gourmand','Evening','Elegant']},
      fsd_b: {name:'The Citrus Alchemist', desc:'Bright, bold, unforgettable. Daylight energy turned all the way up.', traits:['Fresh','Gourmand','Day','Bold']},
      fsd_e: {name:'The Morning Seraph', desc:'Crisp and serene. Clean radiance for effortless days.', traits:['Fresh','Gourmand','Day','Elegant']},
      fdn_b: {name:'The Midnight Captain', desc:'Cool air and quiet authority. Fresh power for late hours.', traits:['Fresh','Woody','Evening','Bold']},
      fdn_e: {name:'The Ocean Whisperer', desc:'Calm, clear, composed. Marine depth with an elegant finish.', traits:['Fresh','Woody','Evening','Elegant']},
      fdd_b: {name:'The Coastal Nomad', desc:'Salt air and open roads. Fresh confidence, wherever the day goes.', traits:['Fresh','Woody','Day','Bold']},
      fdd_e: {name:'The Daylight Luminary', desc:'Bright, polished, quietly assured. Everyday light, done properly.', traits:['Fresh','Woody','Day','Elegant']}
    };


    var catalogue = [
      {num:"No.009", name:"Pineapple Smoke", notes:"Pineapple - Birch - Musk", url:"/products/auurah-no-009-pineapple-smoke", tags:{warmth:"fresh", sweet:"sweet", time:"night", vibe:"bold"}},
      {num:"No.087", name:"Wild Ember", notes:"Bergamot - Pepper - Woods", url:"/products/auurah-no-087-wild-ember", tags:{warmth:"warm", sweet:"dry", time:"day", vibe:"bold"}},
      {num:"No.153", name:"Velvet Night", notes:"Lavender - Vanilla - Amber", url:"/products/auurah-no-153-velvet-night", tags:{warmth:"warm", sweet:"sweet", time:"night", vibe:"bold"}},
      {num:"No.218", name:"Unbound", notes:"Lavender - Orange Blossom - Vanilla", url:"/products/auurah-no-218-unbound", tags:{warmth:"fresh", sweet:"sweet", time:"day", vibe:"elegant"}},
      {num:"No.291", name:"Solstice", notes:"Grapefruit - Ginger - Amber", url:"/products/auurah-no-291-solstice", tags:{warmth:"fresh", sweet:"dry", time:"day", vibe:"bold"}},
      {num:"No.341", name:"Magnetic", notes:"Chestnut - Spice - Vanilla", url:"/products/auurah-no-341-magnetic", tags:{warmth:"warm", sweet:"sweet", time:"day", vibe:"bold"}},
      {num:"No.384", name:"Velvet Bloom", notes:"Pear - Vanilla - Amber", url:"/products/auurah-no-384-velvet-bloom", tags:{warmth:"warm", sweet:"sweet", time:"night", vibe:"elegant"}},
      {num:"No.418", name:"Obsidian", notes:"Leather - Cardamom - Amber", url:"/products/auurah-no-418-obsidian", tags:{warmth:"warm", sweet:"dry", time:"night", vibe:"bold"}},
      {num:"No.456", name:"Crystal Rouge", notes:"Saffron - Jasmine - Amberwood", url:"/products/auurah-no-456-crystal-rouge", tags:{warmth:"warm", sweet:"sweet", time:"night", vibe:"elegant"}},
      {num:"No.527", name:"Dark Eden", notes:"Passion Fruit - Oud - Leather", url:"/products/auurah-no-527-dark-eden", tags:{warmth:"warm", sweet:"dry", time:"night", vibe:"bold"}},
      {num:"No.547", name:"Electric Bloom", notes:"Cherry - Peony - Vanilla", url:"/products/auurah-no-547-electric-bloom", tags:{warmth:"fresh", sweet:"sweet", time:"night", vibe:"bold"}},
      {num:"No.614", name:"Daydream", notes:"Bergamot - Ginger - Black Tea", url:"/products/auurah-no-614-daydream", tags:{warmth:"fresh", sweet:"dry", time:"day", vibe:"elegant"}},
      {num:"No.672", name:"Nomad Shadow", notes:"Oud - Raspberry - Incense", url:"/products/auurah-no-672-nomad-shadow", tags:{warmth:"warm", sweet:"dry", time:"night", vibe:"bold"}},
      {num:"No.734", name:"Imperial Woods", notes:"Rose - Cinnamon - Oud", url:"/products/auurah-no-734-imperial-woods", tags:{warmth:"warm", sweet:"dry", time:"night", vibe:"elegant"}},
      {num:"No.901", name:"Blue Horizon", notes:"Citrus - Ginger - Cedar", url:"/products/auurah-no-901-blue-horizon", tags:{warmth:"fresh", sweet:"dry", time:"day", vibe:"bold"}}
    ];

    function attrsFromKey(key) {
      return {
        warmth: key.charAt(0) === 'f' ? 'fresh' : 'warm',
        sweet: key.charAt(1) === 'd' ? 'dry' : 'sweet',
        time: key.charAt(2) === 'd' ? 'day' : 'night',
        vibe: key.indexOf('_b') > -1 ? 'bold' : 'elegant'
      };
    }

    function wardrobeFor(key) {
      var a = attrsFromKey(key);
      var primaryUrls = (fragrances[key] || []).map(function(f) { return f.url; });
      var pool = catalogue.filter(function(f) { return primaryUrls.indexOf(f.url) === -1; });
      var used = [];
      function take(scoreFn) {
        var best = null, bestScore = -1;
        pool.forEach(function(f) {
          if (used.indexOf(f.url) > -1) return;
          var s = scoreFn(f);
          if (s > bestScore) { bestScore = s; best = f; }
        });
        if (best) used.push(best.url);
        return best;
      }
      var day = take(function(f) {
        return (f.tags.warmth === a.warmth ? 2 : 0) + (f.tags.sweet === a.sweet ? 2 : 0) + (f.tags.time === 'day' ? 3 : 0);
      });
      var evening = take(function(f) {
        return (f.tags.warmth === a.warmth ? 2 : 0) + (f.tags.sweet === a.sweet ? 2 : 0) + (f.tags.time === 'night' ? 3 : 0);
      });
      var wild = take(function(f) {
        return (f.tags.warmth !== a.warmth ? 3 : 0) + (f.tags.vibe === a.vibe ? 1 : 0) + (f.tags.sweet === a.sweet ? 1 : 0);
      });
      return {
        day: {f: day, reason: a.time === 'day' ? 'Everyday polish in your signature family.' : 'A lighter companion for daytime.'},
        evening: {f: evening, reason: a.time === 'night' ? 'Another facet of after dark.' : 'Your after-dark statement.'},
        wild: {f: wild, reason: 'A confident step outside your signature.'}
      };
    }

    function wardrobeCardHtml(slot, label) {
      if (!slot || !slot.f) return '';
      var f = slot.f;
      var h = '<a href="' + esc(f.url) + '" style="text-decoration:none;color:inherit;">';
      h += '<div class="result-card wardrobe-card">';
      h += '<div style="flex:1;">';
      h += '<span class="wardrobe-tag">' + esc(label) + '</span>';
      h += '<div class="result-card__num">AUURAH ' + esc(f.num) + '</div>';
      h += '<div class="result-card__name">' + esc(f.name) + '</div>';
      h += '<div class="result-card__notes">' + esc(f.notes) + '</div>';
      h += '<div class="wardrobe-reason">' + esc(slot.reason) + '</div>';
      h += '<div class="result-card__link">View Fragrance &rarr;</div>';
      h += '</div></div></a>';
      return h;
    }

    function wardrobeSectionHtml(key) {
      var wd = wardrobeFor(key);
      var h = '<h3 class="results-heading wardrobe-heading">Complete Your Scent Wardrobe</h3>';
      h += '<p class="wardrobe-sub">Built around your profile: one for day, one for evening, and one wildcard to surprise you.</p>';
      h += wardrobeCardHtml(wd.day, 'Day');
      h += wardrobeCardHtml(wd.evening, 'Evening');
      h += wardrobeCardHtml(wd.wild, 'Wildcard');
      return h;
    }


    var DISCOVERY_VARIANT_ID = 65528511201629;
    var DISCOVERY_PRICE = '£20';

    function discoveryPicks(key, primaryMatches) {
      var primary = (primaryMatches && primaryMatches.length ? primaryMatches : (fragrances[key] || [])).map(function(f) { return f.name + ' (' + f.num + ')'; });
      var wd = wardrobeFor(key);
      ['day','evening','wild'].forEach(function(s) {
        if (wd[s] && wd[s].f) primary.push(wd[s].f.name + ' (' + wd[s].f.num + ')');
      });
      return primary.slice(0, 3);
    }

    function personalisedBoxHtml(key, primaryMatches, profileName, firstName) {
      var picks = discoveryPicks(key, primaryMatches);
      var h = '<div class="discovery-box" id="quizDiscoveryBox">';
      h += '<p class="discovery-box__label">Personalised Discovery Set</p>';
      h += '<h3 class="discovery-box__title">Your Discovery Set, Designed For You</h3>';
      var sub = 'Based on what you told us you like' + (firstName ? ', ' + esc(firstName) : '') + ', we have designed your Discovery Set to your personal scent profile. Your three fragrances:';
      h += '<p class="discovery-box__sub" id="discoveryBoxSub">' + sub + '</p>';
      h += '<ul class="discovery-box__list">';
      picks.forEach(function(p) { h += '<li>' + esc(p) + '</li>'; });
      h += '</ul>';
      h += '<button type="button" class="discovery-box__btn" data-action="add-discovery" data-key="' + esc(key) + '">Add My Discovery Set - ' + DISCOVERY_PRICE + '</button>';
      h += '<p class="discovery-box__note">Three 5ml samples. Your ' + DISCOVERY_PRICE + ' comes back as credit toward any full-size 100ml bottle.</p>';
      h += '</div>';
      return h;
    }

    function addDiscovery(key) {
      var btn = wrapper.querySelector('[data-action="add-discovery"]');
      if (btn) { btn.disabled = true; btn.textContent = 'Adding your box...'; }
      var profile = profiles[key] || profiles['wsn_b'];
      var picks = discoveryPicks(key, fragrances[key] || []);
      var props = {
        'Scent Profile': profile.name,
        'Your 3 Fragrances': picks.join(', '),
        'Personalised': 'Based on what you told us you like, we have designed this Discovery Set to your personal scent profile'
      };
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: DISCOVERY_VARIANT_ID, quantity: 1, properties: props }] })
      }).then(function(r) { if (!r.ok) throw new Error('cart error'); return r.json(); })
        .then(function() { window.location.href = '/checkout'; })
        .catch(function() {
          if (btn) { btn.disabled = false; btn.textContent = 'Add My Discovery Set - ' + DISCOVERY_PRICE; }
          window.location.href = '/products/auurah-discovery-credit';
        });
    }

    function esc(s) {
      return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
    }

    function updateDots(upTo) {
      var dots = wrapper.querySelectorAll('.quiz-dot');
      dots.forEach(function(d, i) {
        if (i <= upTo) d.classList.add('active');
        else d.classList.remove('active');
      });
    }

    function startQuiz() {
      var intro = document.getElementById('quizIntro');
      var progress = document.getElementById('quizProgress');
      var questions = document.getElementById('quizQuestions');
      if (intro) intro.classList.add('hidden');
      if (progress) progress.style.display = 'flex';
      if (questions) questions.style.display = 'block';
      currentQ = 0;
      quizAnswers = {};
      updateDots(0);
    }

    function answer(qIndex, value) {
      quizAnswers[qIndex] = value;
      var questions = wrapper.querySelectorAll('.quiz-question');
      if (qIndex < questions.length - 1) {
        questions[qIndex].classList.remove('active');
        questions[qIndex + 1].classList.add('active');
        currentQ = qIndex + 1;
        updateDots(qIndex);
      } else {
        questions[qIndex].classList.remove('active');
        var prog = document.getElementById('quizProgress');
        if (prog) prog.style.display = 'none';
        showResults();
      }
    }

    function goBack() {
      var questions = wrapper.querySelectorAll('.quiz-question');
      var intro = document.getElementById('quizIntro');
      var prog = document.getElementById('quizProgress');
      var qDiv = document.getElementById('quizQuestions');
      var resultsDiv = document.getElementById('quizResults');
      var showingResults = resultsDiv && resultsDiv.style.display === 'block' && resultsDiv.innerHTML !== '';
      if (showingResults) {
        resultsDiv.innerHTML = '';
        resultsDiv.style.display = 'none';
        if (prog) prog.style.display = 'flex';
        if (qDiv) qDiv.style.display = 'block';
        var lastQ = questions.length - 1;
        questions[lastQ].classList.add('active');
        currentQ = lastQ;
        updateDots(lastQ);
        return;
      }
      if (currentQ > 0) {
        questions[currentQ].classList.remove('active');
        currentQ = currentQ - 1;
        questions[currentQ].classList.add('active');
        delete quizAnswers[currentQ];
        updateDots(currentQ);
      } else {
        questions[currentQ].classList.remove('active');
        if (prog) prog.style.display = 'none';
        if (qDiv) qDiv.style.display = 'none';
        if (intro) intro.classList.remove('hidden');
        currentQ = 0;
        quizAnswers = {};
        updateDots(-1);
      }
    }

    function profileKey() {
      var warmth = quizAnswers[0] || 'warm';
      var sweetness = quizAnswers[1] || 'sweet';
      var time = quizAnswers[2] || 'night';
      var vibe = quizAnswers[3] || 'bold';
      return warmth.charAt(0) + sweetness.charAt(0) + time.charAt(0) + '_' + vibe.charAt(0);
    }

    function chipsHtml(traits) {
      var h = '<div class="profile-chips">';
      traits.forEach(function(t) { h += '<span class="profile-chip">' + esc(t) + '</span>'; });
      return h + '</div>';
    }

    function profileCardHtml(name, desc, traits, label) {
      var h = '<div class="profile-card">';
      h += '<p class="profile-card__label">' + esc(label) + '</p>';
      h += '<h3 class="profile-card__name">' + esc(name) + '</h3>';
      h += '<p class="profile-card__desc">' + esc(desc) + '</p>';
      h += chipsHtml(traits);
      return h + '</div>';
    }

    function matchCardHtml(f) {
      var h = '<a href="' + esc(f.url) + '" style="text-decoration:none;color:inherit;">';
      h += '<div class="result-card">';
      h += '<div style="flex:1;">';
      h += '<div class="result-card__num">AUURAH ' + esc(f.num) + '</div>';
      h += '<div class="result-card__name">' + esc(f.name) + '</div>';
      h += '<div class="result-card__notes">' + esc(f.notes) + '</div>';
      h += '<div class="result-card__link">View Fragrance &rarr;</div>';
      h += '</div></div></a>';
      return h;
    }

    function emailFormHtml() {
      var h = '<div class="quiz-save" id="quizSaveBox">';
      h += '<p class="quiz-save__title">Save your profile</p>';
      h += '<p class="quiz-save__sub">Enter your first name and email and we will keep your matches safe and send them to you.</p>';
      h += '<div class="quiz-save__form">';
      h += '<input type="text" id="quizFirstName" class="quiz-save__input quiz-save__input--name" placeholder="First name" autocomplete="given-name">';
      h += '<input type="email" id="quizEmail" class="quiz-save__input" placeholder="Email address" autocomplete="email">';
      h += '<button type="button" class="quiz-save__btn" data-action="save-email">Save My Profile</button>';
      h += '</div>';
      h += '<p class="quiz-save__note">No spam. Just your scent matches and new arrivals suited to your profile.</p>';
      h += '</div>';
      return h;
    }

    function showResults() {
      var key = profileKey();
      lastKey = key;
      var profile = profiles[key] || profiles['wsn_b'];
      var results = fragrances[key] || fragrances['wsn_b'];
      var html = '<div class="quiz-results active">';
      html += profileCardHtml(profile.name, profile.desc, profile.traits, 'Your Scent Profile');
      html += '<h3 class="results-heading">Your Perfect Matches</h3>';
      results.forEach(function(f) { html += matchCardHtml(f); });
      html += wardrobeSectionHtml(key);
      var savedPre = getSaved();
      html += personalisedBoxHtml(key, results, profile.name, savedPre && savedPre.firstName ? savedPre.firstName : '');
      html += emailFormHtml();
      html += '<p class="quiz-restart" data-action="back" style="margin-top:16px;">&larr; Back to last question</p>';
      html += '<p class="quiz-restart" data-action="restart" style="margin-top:8px;">Take the quiz again</p>';
      html += '</div>';
      var resultsDiv = document.getElementById('quizResults');
      if (resultsDiv) {
        resultsDiv.innerHTML = html;
        resultsDiv.style.display = 'block';
      }
      var qDiv = document.getElementById('quizQuestions');
      if (qDiv) qDiv.style.display = 'none';
    }

    function getSaved() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        var data = JSON.parse(raw);
        if (!data || !data.key || !data.name) return null;
        return data;
      } catch (e) { return null; }
    }

    function saveProfile() {
      var input = document.getElementById('quizEmail');
      var email = input ? input.value.trim() : '';
      var nameInput = document.getElementById('quizFirstName');
      var firstName = nameInput ? nameInput.value.trim().replace(/[^a-zA-Z '\-]/g, '') : '';
      var errMsg = '';
      if (!firstName) errMsg = 'Please enter your first name.';
      else if (!email || email.indexOf('@') < 1 || email.indexOf('.') < 3) errMsg = 'Please enter a valid email address.';
      if (errMsg) {
        var box0 = document.getElementById('quizSaveBox');
        var msg0 = document.getElementById('quizSaveMsg');
        if (box0) {
          if (!msg0) {
            var p = document.createElement('p');
            p.id = 'quizSaveMsg';
            p.className = 'quiz-save__msg err';
            box0.appendChild(p);
            msg0 = p;
          }
          msg0.textContent = errMsg;
        }
        return;
      }
      var key = lastKey || profileKey();
      var profile = profiles[key] || profiles['wsn_b'];
      var results = fragrances[key] || fragrances['wsn_b'];
      function klaviyoPixel(endpoint, payload) {
        try {
          var json = JSON.stringify(payload);
          var b64 = btoa(unescape(encodeURIComponent(json)));
          var img = new Image();
          img.src = 'https://a.klaviyo.com/api/' + endpoint + '?data=' + encodeURIComponent(b64);
        } catch (e) {}
      }
      klaviyoPixel('identify', {
        token: 'WLuk7C',
        properties: {
          'email': email,
          'first_name': firstName,
          'Scent Profile': profile.name,
          'Profile Description': profile.desc,
          'Profile Warmth': quizAnswers[0] || '',
          'Profile Sweetness': quizAnswers[1] || '',
          'Profile Time': quizAnswers[2] || '',
          'Profile Vibe': quizAnswers[3] || '',
          'Wardrobe Picks': (function(k) {
            var wd = wardrobeFor(k);
            return [wd.day.f && wd.day.f.name, wd.evening.f && wd.evening.f.name, wd.wild.f && wd.wild.f.name].filter(Boolean).join(', ');
          })(lastKey || profileKey())
        }
      });
      klaviyoPixel('track', {
        token: 'WLuk7C',
        event: 'Completed Scent Profile',
        customer_properties: {
          'email': email,
          'first_name': firstName
        },
        properties: {
          'First Name': firstName,
          'Scent Profile': profile.name,
          'Profile Description': profile.desc,
          'Perfect Matches': results.map(function(f) { return f.name + ' (' + f.num + ')'; }).join(', '),
          'Wardrobe Picks': (function(k) {
            var wd = wardrobeFor(k);
            return [wd.day.f && wd.day.f.name, wd.evening.f && wd.evening.f.name, wd.wild.f && wd.wild.f.name].filter(Boolean).join(', ');
          })(key),
          'Discovery Box Picks': discoveryPicks(key, results).join(', ')
        }
      });
      var data = {
        key: key,
        name: profile.name,
        desc: profile.desc,
        traits: profile.traits,
        matches: results.map(function(f) { return {num: f.num, name: f.name, notes: f.notes, url: f.url}; }),
        firstName: firstName,
        email: email,
        ts: Date.now()
      };
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(data)); } catch (e) {}
      var box = document.getElementById('quizSaveBox');
      if (box) {
        box.innerHTML = '<p class="quiz-save__title">Profile saved</p>';
        box.innerHTML += '<p class="quiz-save__sub">Thank you, ' + esc(firstName) + '. Your matches are saved to ' + esc(email) + '. We will also remember your profile next time you visit.</p>';
      }
      var subEl = document.getElementById('discoveryBoxSub');
      if (subEl) {
        subEl.textContent = 'Based on what you told us you like, ' + firstName + ', we have designed your Discovery Set to your personal scent profile. Your three fragrances:';
      }
      renderWelcomeBack();
    }

    function showSavedResults() {
      var data = getSaved();
      if (!data) return;
      lastKey = data.key;
      var html = '<div class="quiz-results active">';
      html += profileCardHtml(data.name, data.desc, data.traits || [], 'Your Saved Scent Profile');
      html += '<h3 class="results-heading">Your Matches</h3>';
      (data.matches || []).forEach(function(f) { html += matchCardHtml(f); });
      html += wardrobeSectionHtml(data.key);
      html += personalisedBoxHtml(data.key, data.matches, data.name, data.firstName || '');
      html += emailFormHtml();
      html += '<p class="quiz-restart" data-action="restart" style="margin-top:16px;">Take the quiz again</p>';
      html += '</div>';
      var intro = document.getElementById('quizIntro');
      if (intro) intro.classList.add('hidden');
      var resultsDiv = document.getElementById('quizResults');
      if (resultsDiv) {
        resultsDiv.innerHTML = html;
        resultsDiv.style.display = 'block';
      }
      var qDiv = document.getElementById('quizQuestions');
      if (qDiv) qDiv.style.display = 'none';
      var prog = document.getElementById('quizProgress');
      if (prog) prog.style.display = 'none';
      var savedInput = document.getElementById('quizEmail');
      if (savedInput && data.email) savedInput.value = data.email;
      var savedName = document.getElementById('quizFirstName');
      if (savedName && data.firstName) savedName.value = data.firstName;
    }

    function renderWelcomeBack() {
      var data = getSaved();
      var slot = document.getElementById('quizWelcomeBack');
      if (!data || !slot) return;
      var who = data.firstName ? data.firstName : data.name;
      var html = 'Welcome back, <span class="welcome-back__name">' + esc(who) + '</span>.';
      html += '<br><button type="button" class="welcome-back__btn" data-action="view-saved">View My Matches</button>';
      slot.innerHTML = html;
      slot.style.display = 'block';
    }

    function restartQuiz() {
      var resultsDiv = document.getElementById('quizResults');
      if (resultsDiv) {
        resultsDiv.innerHTML = '';
        resultsDiv.style.display = 'none';
      }
      wrapper.querySelectorAll('.quiz-question').forEach(function(q) { q.classList.remove('active'); });
      var q0 = wrapper.querySelector('[data-q="0"]');
      if (q0) q0.classList.add('active');
      var prog = document.getElementById('quizProgress');
      if (prog) prog.style.display = 'flex';
      var qDiv = document.getElementById('quizQuestions');
      if (qDiv) qDiv.style.display = 'block';
      wrapper.querySelectorAll('.quiz-dot').forEach(function(d, i) {
        if (i === 0) d.classList.add('active');
        else d.classList.remove('active');
      });
      currentQ = 0;
      quizAnswers = {};
    }

    function handle(e) {
      var btn = e.target.closest('[data-action]');
      if (!btn) return;
      var action = btn.getAttribute('data-action');
      if (action === 'start') {
        e.preventDefault();
        startQuiz();
      } else if (action === 'answer') {
        e.preventDefault();
        var qi = parseInt(btn.getAttribute('data-q-index'), 10);
        var val = btn.getAttribute('data-value');
        answer(qi, val);
      } else if (action === 'restart') {
        e.preventDefault();
        restartQuiz();
      } else if (action === 'back') {
        e.preventDefault();
        goBack();
      } else if (action === 'save-email') {
        e.preventDefault();
        saveProfile();
      } else if (action === 'add-discovery') {
        e.preventDefault();
        addDiscovery(btn.getAttribute('data-key'));
      } else if (action === 'view-saved') {
        e.preventDefault();
        showSavedResults();
      }
    }

    wrapper.addEventListener('click', handle);
    renderWelcomeBack();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  setTimeout(init, 500);
  setTimeout(init, 1500);

  /* Hash navigation: reliably scroll to the quiz when arriving via /#fragranceFinder */
  function scrollToQuiz() {
    var el = document.getElementById('fragranceFinder');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  function handleHash() {
    if (window.location.hash === '#fragranceFinder') {
      setTimeout(scrollToQuiz, 300);
      setTimeout(scrollToQuiz, 1200);
    }
  }
  window.addEventListener('hashchange', handleHash);
  handleHash();
})();
